import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Box, Container } from '@material-ui/core';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { green } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import img1 from '../img/img1.jfif';
import img2 from '../img/img11.jfif';
import img3 from '../img/img12.jfif';
import img4 from '../img/img2.jfif';
import img5 from '../img/img10.jfif';
import img6 from '../img/img15.jfif';
import img7 from '../img/img8.jfif';
import img8 from '../img/img16.jfif';
import img9 from '../img/img3.jfif';


const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(3),
  },
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: green[500],
  },
  heading: {
      fontSize:1,
      
  }
  

}));

export default function Product() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <Container maxWidth="md" fixed  >
        <Box mt="50px">
        <div className="top_head col-10 mx-auto">
            <div className="row">
                <h6>Product</h6>
            </div>
        </div>    
      <Grid container spacing={3} direction="row" justify="center" alignItems="center" >
                {/*Card One */} 
        <Grid item sm={4}>
        <Card id="allminCard" name="allminCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            AM
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="All Min"
        subheader="Unique Mineral Mixture For Aquaculture."
      />
      <CardMedia
        className={classes.media}
        image={img1}
        title="AllMin"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
           All the Micro & Macro minerals fortified 
           with Vitamins & Enzymes.
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>10 to 20Kg/acre weekly once.</Typography>
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Promotes desired level of all mineral at optimum level in water.</li>
             <li>Helps in muscle formation.</li>
             <li>Helps to prevent body cramp.</li>
             <li>Regulates periodic moulting.</li>
             <li>Prevents loose shell & keeps animal healthy.</li>
             <li>Helps in growth & reduces FCR.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
                {/*Card Two */} 
        <Grid item sm={4}>
        <Card id="sConditionerCard" name="sConditionerCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            SC
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="S-CONDITIONER"
        subheader="Special products to condition the soil."
      />
      <CardMedia
        className={classes.media}
        image={img2}
        title="S-CONDITIONER"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Multiple strains of Bacillus Spp added with quality minerals.    
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>
            <ol>
                <li> During pond preparation 20Kg/acre.</li>
                <li>During culture 10-15 Kg/acre weekly.</li>
            </ol>
        </Typography>
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Enhances the pond productivity.</li>
             <li>Keeps the pond bottom clean & reduces toxins level.</li>
             <li>Improves the fertility of soil.</li>
             <li>Improves the fertility of soil.</li>
             <li> Regulates the moulting.</li>
             
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
                {/*Card Three */} 
        <Grid item sm={4}>
        <Card id="softnerCard" name="softnerCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            S
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="SOFTENER"
        subheader="Special Water
        Softener...."
      />
      <CardMedia
        className={classes.media}
        image={img3}
        title="SOFTENER"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        EDTA & Sulphate of Ca,Mg,Mn,Zn & Cu.
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>2Kg/acre depending upon the water quality.</Typography>
        
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Removes the hardness of water.</li>
             <li>Nutralize the toxicity of ammonia</li>
             <li>Detoxifies the toxic iron contents.</li>
             <li>Prevents the frequent plankton crash.</li>
             <li>Makes bore water suitable for culture.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
      </Grid>

          {/********************Second Line***********************/}

          <Grid container spacing={3} direction="row" justify="center" alignItems="center" >
                {/*Card One */} 
        <Grid item sm={4}>
        <Card id="zeostarCard" name="zeostarCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            ZS
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="ZeoStar"
        subheader="Technical Grade Zeolite Added With Yucca."
      />
      <CardMedia
        className={classes.media}
        image={img4}
        title="ZeoStar"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Sodium Alumino Silicate, Oxides of ferrous,Ca & Mg added with yucca powder.
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
            <ol>
                <li>During pond preparation 40Kg/acre.</li>
                <li>During culture 10-20 Kg/acre depending upon the water & soil condition.</li>
            </ol>
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Purifies water & improves DO level.</li>
             <li>Reduces turbidity.</li>
             <li>Absorvs toxic gases & improves soil quality.</li>
             <li>Keeps animal stress free.</li>
             <li>Helps in growth.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
                {/*Card Two */} 
        <Grid item sm={4}>
        <Card id="plankboostCard" name="plankboostCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            PB
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="PlanktoBoost"
        subheader="Natural Plankton Developer."
      />
      <CardMedia
        className={classes.media}
        image={img5}
        title="PlanktoBoost"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Biologically active fermented plant extract added with micro & macro minerals.
        </Typography>
    
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>
        5 Ltr /acre weekly
        </Typography>
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
            <li>Develops natural productivity of Phyto & Zoo plankton</li>
            <li>Reduces the usage of inorganic fertilizers.</li>
            <li>Reduces the usage of lime.</li>
            <li>Reduces the usage of lime.</li>
            <li>Maintains the optimum temperature.</li>
            <li>Regulates the pH .</li>
             
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
                {/*Card Three */} 
        <Grid item sm={4}>
        <Card id="vitCard" name="vitCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            VC
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="Vit -C"
        subheader="Unique Combination of Muiltivitamin"
      />
      <CardMedia
        className={classes.media}
        image={img6}
        title="Vit -C"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Vitamin C & E in major proportion & other vitamins as a trace amount..
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>Vit C & E in major proportion & other vitamins as a trace amount.</Typography>
       
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Collagen synthesis which plays a major role in muscle development of fish & shrimp</li>
             <li>Prevents & controls stress due to bacterial, viral, fungal contamination.</li>
             <li>Prevents & controls stress due to bacterial, viral, fungal contamination.</li>
             <li>Keeps the animal active.</li>
             <li>Helps in growth & reduces FCR.</li>
             <li>Acts as immuno modulator.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
      </Grid>
 
          {/*Third Line */}

          <Grid container spacing={3} direction="row" justify="center" alignItems="center" >
                {/*Card One */} 
        <Grid item sm={4}>
        <Card id="livgelCard" name="livgelCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            LG
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="LivGel"
        subheader="Binder cum feed attractant added.. "
      />
      <CardMedia
        className={classes.media}
        image={img7}
        title="LivGel"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Concentrated protein, vitamins & yeast in Gel form.
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>10 to 20 ml/Kg of feed along with feed supplements.</Typography>
      
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Acts as a good binder.</li>
             <li>Prevents lever/hepatopancreatic disorders.</li>
             <li>Improves body weight with better FCR.</li>
             <li>Regulates the periodic moulting.</li>
             <li>Keeps animal stress free.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
                {/*Card Two */} 
        <Grid item sm={4}>
        <Card id="yeastCard" name="yeastCard" className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            YP
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="YeastPro"
        subheader="Best quality yeast for aquaculture."
      />
      <CardMedia
        className={classes.media}
        image={img8}
        title="YeastPro"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Yeast Pro is a mixture of Saccharomyces and Bacillus spp.    
        </Typography>
        
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>
            <ol>
                <li><strong>Feed application:</strong> 5gm/Kg of feed</li>
                <li><strong>Water Application:</strong> 0.5 to 1Kg/acre</li>
            </ol>
        </Typography>
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Helps in fermentation.</li>
             <li>Enhances survival rate & growth.</li>
             <li>Improves disease resistance.</li>
             <li>proves FCR and lowers feed cost.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
                {/*Card Three */} 
        <Grid item sm={4}>
        <Card id="bottomCareCard"  name="bottomCareCard" className={classes.rootn}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            BC
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="BottomCare"
        subheader="Concentrated water & soil probiotic."
      />
      <CardMedia
        className={classes.media}
        image={img9}
        title="BottomCare"
      />
      <CardContent>
        <Typography variant="h4" color="textSecondary" heading >
          COMPOSITION:
        </Typography>
        <Typography paragraph>
        Different Spp of Bacillus ,Rhodococcus,Rhodobactor..
        </Typography>
         
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>DOSAGE:</Typography>
        <Typography paragraph>5Kg/acre weekly</Typography>
     
          <Typography paragraph>FUNCTION:</Typography>
         <ol>
             <li>Degrades the organic matter quickly.</li>
             <li>Prevents the formation of toxic gases.</li>
             <li>Develops the plankton level.</li>
             <li>Helps to reduce disease caused by microorganism.</li>
             <li>Increases immunity & growth.</li>
         </ol>
          
        </CardContent>
      </Collapse>
    </Card>
        </Grid>
      </Grid>
 

      </Box>
    </Container>
  );
}
